module.exports = __webpack_public_path__ + "static/media/icon-comment-selected.845bbe2f.svg";